export default "__VITE_ASSET__BhNTMjfg__"